import { ClientConfig } from 'client/configuration';

export function isMockVin(vin) {
  const { mockVin, mockUsedVin } = ClientConfig.get('carBuying');
  return vin === mockVin || vin === mockUsedVin;
}
